import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class BusinessActivityDurationsService {
    constructor(private http:Http) {
    }

    private businessActivityDurationsProfiles: Array<any>;

    getBusinessActivityDurations(): Observable<Array<any>> {
        if (isEmpty(this.businessActivityDurationsProfiles)) {
            return this.http.get('/api/client/dictionary/business_activity_durations')
                .map(response => response.json())
                .map(response => {
                    this.businessActivityDurationsProfiles = response.businessActivityDurations;
                    return this.businessActivityDurationsProfiles;
                });
        } else {
            return Observable.of(this.businessActivityDurationsProfiles);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/business.activity.durations.service.ts